import { Component, Inject } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { DeviceDetectorService } from 'ngx-device-detector';
import { QuoteService } from '../../quote/services/quote.service';
import { AbstractBiditComponent } from '../../shared/controls/abstract.bidit.component';
import { ItemMaster } from '../../shared/models/item.master.interface';
import { ItemType } from '../../shared/models/item.type.interface';
import { ItemUsage } from '../../shared/models/item.usage.interface';
import { JobAdditionalItem } from '../../shared/models/job.additional.item.interface';
import { RValue } from '../../shared/models/r.value.interface';

export interface JobCostItemDialogData {
}

@Component({
    selector: 'app-job-cost-item-dialog',
    templateUrl: './job-cost-item.dialog.html',
    styleUrls: ['./job-cost-item.dialog.scss']
})
/** job-cost-item-dialog component*/
export class JobCostItemDialog extends AbstractBiditComponent {

  itemTypes: ItemType[];
  productRValues: RValue[];
  productItems: ItemMaster[];
  productUsages: ItemUsage[];

  productFilterItemType_ID: number;
  productFilterRValue: number;

  additionalItem: JobAdditionalItem = {} as JobAdditionalItem;

  productUsage: boolean = false;

    /** job-cost-item-dialog ctor */
  constructor(
    private quoteService: QuoteService,
    deviceDetectorService: DeviceDetectorService,
    public dialogRef: MatDialogRef<JobCostItemDialog>,
    @Inject(MAT_DIALOG_DATA) public data: JobCostItemDialogData) {
    super(deviceDetectorService);

    quoteService.getItemTypes()
      .subscribe(result => {
        this.itemTypes = result;

        this.refreshProductItems();
      });
  }

  refreshProductItemType(): void {
    this.productFilterRValue = null;
    let itemType = this.itemTypes.find(it => it.itemType_ID == this.productFilterItemType_ID);
    this.productUsage = (itemType != null && itemType.itemCoverageType_ID != null);

    this.refreshProductItems();
  }

  refreshProductItems(): void {
    this.quoteService.getRValues(this.productFilterItemType_ID)
      .subscribe({
        next: (data) => {
          this.productRValues = data;
        },
        error: (error: string) => this.onError(error)
      });

    if (this.productFilterItemType_ID == null) {
      this.productItems = null;
      return;
    }

    this.quoteService.getItems(this.productFilterItemType_ID, this.productFilterRValue)
      .subscribe({
        next: (data) => {
          this.productItems = data;
        },
        error: (error: string) => this.onError(error)
      });

  }

  refreshProductUsages() {
    this.quoteService.getItemUsages(this.additionalItem.item_ID)
      .subscribe({
        next: (data) => {
          this.productUsages = data;
        },
        error: (error: string) => this.onError(error)
      });
  };

  addCustomItem(form: NgForm) {    
    if (form.valid) {
      this.additionalItem.item = this.productItems.find(i => i.item_ID == this.additionalItem.item_ID);
      
      this.dialogRef.close(this.additionalItem);
    }
  }

  onNoClick(): void {
    this.dialogRef.close();
  }
}
